import pilotTemplatesApi from '@api/pilotTemplates'

/**
 * Verified pilot hiring templates and the current signup intent.
 */
const state = {
  templates: null,
  nextAction: null,
  maxExams: 6,
  error: null,
  intent: null
}

const mutations = {
  templates (state, payload) {
    state.templates = payload.templates || []
    state.nextAction = payload.nextAction || null
    state.maxExams = payload.maxExams || 6
    state.error = null
  },

  error (state, error) {
    state.error = error
  },

  intent (state, intent) {
    state.intent = intent
  }
}

const getters = {
  haveTemplatesLoaded: state => state.templates !== null,

  templates: state => state.templates || [],

  templateBySlug: state => slug => (state.templates || []).find(template => template.slug === slug) || null,

  nextAction: state => state.nextAction || 'Invite your first candidate',

  maxExams: state => state.maxExams,

  intent: state => state.intent,

  templatesError: state => state.error
}

const actions = {
  /**
   * @return {Promise}
   */
  getTemplates ({ commit, state }) {
    if (state.templates !== null) {
      return Promise.resolve(state.templates)
    }
    return pilotTemplatesApi.index()
      .then(payload => {
        commit('templates', payload)
        return state.templates
      })
      .catch(error => {
        commit('error', error)
        throw error
      })
  },

  setIntent ({ commit }, intent) {
    commit('intent', intent || null)
  }
}

export { state, mutations, getters, actions }
